import React from 'react';
import { withSvgWrap } from "../SvgWrap";
export var GooglePlayIcon = withSvgWrap( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M1.4 1.8c-.3.4-.5.9-.5 1.6v24.3c0 .7.2 1.2.5 1.5v.1l14-13.6v-.3L1.4 1.7v.1Z",
  fill: "url(#gpl_a)",
  "data-t-id": "icons-GooglePlayIcon"
}), /*#__PURE__*/React.createElement("path", {
  d: "m20 20.2-4.6-4.5v-.3l4.6-4.6h.1l5.5 3.1c1.6 1 1.6 2.3 0 3.2l-5.5 3v.1Z",
  fill: "url(#gpl_b)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m20.1 20.2-4.7-4.7-14 13.7c.5.6 1.4.6 2.3.1l16.4-9.1Z",
  fill: "url(#gpl_c)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.1 10.9 3.7 1.8c-1-.6-1.8-.5-2.3 0l14 13.7L20 11Z",
  fill: "url(#gpl_d)"
}), /*#__PURE__*/React.createElement("path", {
  /* eslint-disable-next-line max-len */
  d: "M39.5 27.5c1.1 0 2.1-.2 3-.7.8-.4 1.5-1 2-1.9.4-.8.7-1.8.7-2.9v-1.6h-5.4V22H43v.3c0 .7-.1 1.3-.4 1.8-.3.5-.8.9-1.3 1.2a4 4 0 0 1-1.9.4c-.8 0-1.5-.2-2.1-.6a4 4 0 0 1-1.4-1.8 7 7 0 0 1-.5-2.7c0-1 .2-2 .5-2.7a3.6 3.6 0 0 1 3.5-2.4c.9 0 1.6.3 2.2.7.6.4 1 1 1.3 1.8h2a5 5 0 0 0-2.9-3.7c-.7-.4-1.6-.6-2.6-.6a5.6 5.6 0 0 0-5.3 3.2c-.5 1.1-.8 2.3-.8 3.7 0 1.4.3 2.7.7 3.7.5 1 1.2 1.8 2.2 2.4.9.5 2 .8 3.2.8ZM50.8 27.4c1 0 1.8-.2 2.5-.6.7-.4 1.2-1 1.6-1.8.4-.8.5-1.7.5-2.7 0-1.1-.1-2-.5-2.8-.4-.8-1-1.3-1.6-1.8-.7-.4-1.6-.6-2.5-.6-1 0-1.8.2-2.5.6-.7.5-1.3 1-1.6 1.8-.4.8-.6 1.7-.6 2.7 0 1.1.2 2 .6 2.8.3.8.9 1.4 1.6 1.8.7.4 1.5.6 2.5.6Zm0-1.7c-.6 0-1-.1-1.5-.4-.4-.3-.7-.6-.9-1.2a5 5 0 0 1-.3-1.8c0-.8.1-1.4.3-2 .2-.4.5-.8 1-1.1.3-.3.8-.4 1.4-.4.5 0 1 .1 1.4.4.4.3.7.7.9 1.2.2.5.3 1.1.3 1.9a5 5 0 0 1-.3 1.8c-.2.6-.5 1-.9 1.2-.4.3-.9.4-1.4.4ZM60.8 27.4c1 0 1.8-.2 2.5-.6.7-.4 1.3-1 1.6-1.8.4-.8.6-1.7.6-2.7 0-1.1-.2-2-.6-2.8-.3-.8-.9-1.3-1.6-1.8-.7-.4-1.5-.6-2.5-.6s-1.7.2-2.4.6c-.7.5-1.3 1-1.7 1.8-.3.8-.5 1.7-.5 2.7 0 1.1.2 2 .5 2.8.4.8 1 1.4 1.7 1.8.7.4 1.5.6 2.4.6Zm0-1.7c-.5 0-1-.1-1.4-.4-.4-.3-.7-.6-.9-1.2a5 5 0 0 1-.3-1.8c0-.8 0-1.4.3-2 .2-.4.5-.8 1-1.1.3-.3.8-.4 1.3-.4.6 0 1 .1 1.5.4.4.3.7.7.9 1.2.2.5.3 1.1.3 1.9a5 5 0 0 1-.3 1.8c-.2.6-.5 1-1 1.2-.3.3-.8.4-1.4.4ZM71 30.7a6 6 0 0 0 2.3-.5c.7-.3 1.3-.7 1.6-1.3.4-.5.6-1.2.6-1.9v-9.7h-2V19a3.3 3.3 0 0 0-1.9-1.5c-.3-.2-.8-.3-1.2-.3-.9 0-1.6.2-2.2.7-.7.4-1.1 1-1.5 1.7-.3.7-.5 1.5-.5 2.5s.2 1.7.5 2.5a4 4 0 0 0 1.4 1.6c.7.4 1.4.6 2.2.6.5 0 .9 0 1.3-.2a3.2 3.2 0 0 0 1.8-1.4h.1V27c0 .7-.2 1.2-.7 1.5a3 3 0 0 1-1.9.6c-.6 0-1.2-.1-1.5-.3-.4-.2-.7-.5-.8-.9h-2c0 .6.3 1 .7 1.5.3.4.8.7 1.4 1 .6.2 1.4.3 2.2.3Zm-.1-5.6c-.6 0-1-.1-1.4-.4l-1-1-.2-1.7c0-.7 0-1.2.3-1.7.2-.4.5-.8.9-1 .3-.3.8-.5 1.4-.5.5 0 1 .2 1.4.4l1 1.1c.2.5.3 1 .3 1.7 0 .6-.1 1.1-.4 1.6-.2.5-.5.8-.9 1.1-.4.3-.9.4-1.4.4ZM77.3 27.2h2V13.5h-2v13.7ZM85.2 27.4c.6 0 1.2 0 1.7-.3.5-.1.9-.3 1.2-.6l.9-.9.4-1h-1.9c0 .2-.2.4-.4.5l-.8.5a3 3 0 0 1-1 .2c-.6 0-1.1-.2-1.5-.4-.4-.2-.7-.6-1-1-.2-.5-.3-1-.3-1.7v-.8c0-.7.1-1.3.4-1.7.2-.5.5-.8.9-1 .4-.3.8-.4 1.3-.4s1 0 1.3.3c.4.2.7.6.9 1 .2.5.3 1 .3 1.8v.8l1-1.3h-7v1.4h8V22c0-1-.2-1.9-.6-2.6a4 4 0 0 0-1.5-1.7c-.7-.5-1.5-.7-2.4-.7-1 0-1.7.2-2.4.7-.7.4-1.2 1-1.6 1.8-.4.7-.6 1.6-.6 2.7 0 1 .2 2 .6 2.7.4.8 1 1.4 1.6 1.8.7.4 1.5.6 2.5.6ZM96 22.7h4c.9 0 1.6-.2 2.3-.5a4 4 0 0 0 1.5-1.6c.4-.6.6-1.4.6-2.2 0-.9-.2-1.6-.6-2.3-.4-.6-.9-1.1-1.5-1.5-.7-.4-1.4-.5-2.3-.5h-4v1.7h3.5c.9 0 1.6.2 2 .7.5.4.8 1 .8 1.9 0 .8-.3 1.4-.7 2-.5.4-1.2.6-2.1.6h-3.6v1.7Zm-1.1 4.5h2V14.1h-2v13.1ZM105.7 27.2h2V13.5h-2v13.7ZM112.2 27.4l1.2-.2a3 3 0 0 0 1.7-1.4h.2v1.4h2v-6.8c0-.7-.2-1.2-.5-1.7s-.7-1-1.3-1.2a5 5 0 0 0-2.1-.4c-.8 0-1.5.1-2 .4-.6.2-1 .5-1.4 1-.4.3-.6.8-.7 1.3v.1h2c0-.4.3-.7.6-.8.4-.2.8-.3 1.4-.3.6 0 1.1.1 1.5.4.3.3.5.7.5 1.2v3.1c0 .5-.1.9-.3 1.2l-1 .8c-.3.2-.8.3-1.3.3s-1-.1-1.3-.4c-.3-.3-.5-.6-.5-1 0-.5.2-.9.5-1.1.3-.3.8-.4 1.5-.4l3.4-.3v-1.4l-3.7.3c-1.2 0-2 .3-2.7.8-.7.5-1 1.2-1 2.1 0 .6.2 1.1.4 1.6.3.4.7.8 1.2 1 .5.2 1 .4 1.7.4ZM119.5 30.7c.7 0 1.3-.1 1.7-.3.5-.2 1-.5 1.3-1l.9-1.8 3.7-10.3H125l-2.8 9 .6-1h-.7l.6 1-2.8-9h-2.2l3.6 10-.1.4a2 2 0 0 1-.7 1c-.3.3-.6.4-1 .4a7.1 7.1 0 0 1-.8 0v1.5a4.1 4.1 0 0 0 .8 0ZM37 4.9h1a1.2 1.2 0 0 0 1.4-1.2c0-.6-.5-1-1.3-1a1.3 1.3 0 0 0-1.5 1h-1a2.3 2.3 0 0 1 2.5-2c1.4 0 2.4.7 2.4 1.9a1.7 1.7 0 0 1-1.3 1.7 1.7 1.7 0 0 1 1.6 1.8 2.4 2.4 0 0 1-2.7 2.2A2.4 2.4 0 0 1 35.4 7h1c.1.7.8 1.2 1.7 1.2 1 0 1.6-.6 1.6-1.3C39.7 6.3 39 6 38 6h-1v-1ZM42 7.5c0-1 .8-1.5 2.1-1.6h1.5v-.6c0-.5-.4-.9-1.1-.9-.6 0-1 .3-1.2.6h-1c0-.9 1-1.5 2.2-1.5 1.4 0 2.2.7 2.2 1.8v3.8h-1v-.8h-.2a1.8 1.8 0 0 1-1.6.9 1.7 1.7 0 0 1-1.8-1.7Zm3.6-.4v-.5h-1.3c-.8.1-1.1.4-1.1.9s.4.8 1 .8A1.3 1.3 0 0 0 45.6 7ZM49.5 4.5v4.6h-1V3.6H52v1h-2.6ZM58.6 6.3c0 1.8-.8 2.9-2.2 2.9a1.8 1.8 0 0 1-1.7-1h-.1V11h-1V3.6h1v.9a2 2 0 0 1 1.8-1c1.4 0 2.2 1 2.2 2.8Zm-1 0c0-1.1-.6-1.8-1.5-1.8-1 0-1.5.7-1.5 1.8 0 1.2.5 1.9 1.5 1.9.9 0 1.4-.7 1.4-1.9ZM60 11v-.9h.4a1 1 0 0 0 1-.7l.1-.3-2-5.5h1.2L62.1 8l1.4-4.4h1.2l-2 5.7c-.5 1.3-1 1.8-2.2 1.8h-.4ZM65.5 7.5h1.1c.1.5.6.8 1.2.8.7 0 1.2-.4 1.2-.8 0-.6-.4-.8-1.2-.8H67v-.9h.8c.6 0 1-.2 1-.7 0-.4-.4-.7-1-.7s-1 .3-1.1.7h-1a2 2 0 0 1 2-1.6c1.4 0 2.1.6 2.1 1.5a1.1 1.1 0 0 1-.8 1.1v.1a1.2 1.2 0 0 1 1 1.3c0 1-.8 1.7-2.2 1.7-1.2 0-2.2-.6-2.3-1.7ZM71.6 9V3.7h1v3.8h.2l2.5-3.8h1v5.5h-1V5.3h-.1L72.7 9h-1.1ZM82.3 4.5h-1.8v4.6h-1V4.5h-1.8v-.9h4.6v1ZM88.1 7.6a2.2 2.2 0 0 1-2.4 1.6 2.5 2.5 0 0 1-2.5-2.8 2.5 2.5 0 0 1 2.5-3c1.5 0 2.5 1.1 2.5 2.9v.3h-4v.1a1.4 1.4 0 0 0 1.6 1.6 1.3 1.3 0 0 0 1.3-.7h1Zm-3.8-1.8H87a1.3 1.3 0 0 0-1.4-1.4 1.4 1.4 0 0 0-1.4 1.4ZM92.7 3.6h2.5c1 0 1.7.5 1.7 1.4a1.2 1.2 0 0 1-1 1.2 1.3 1.3 0 0 1 1.2 1.3c0 1-.7 1.6-2 1.6h-2.4V3.6Zm1 .8v1.4h1.1c.7 0 1-.2 1-.7 0-.4-.3-.7-.8-.7h-1.2Zm0 2.2v1.7H95c.7 0 1-.3 1-.8 0-.6-.4-.9-1-.9h-1.2Z"
}), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  gradientUnits: "userSpaceOnUse",
  id: "gpl_a",
  x1: "14.2",
  x2: "-4.3",
  y1: "28",
  y2: "9.1"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#00A0FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "0",
  stopColor: "#00A1FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".3",
  stopColor: "#00BEFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".5",
  stopColor: "#00D2FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".8",
  stopColor: "#00DFFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#00E3FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  gradientUnits: "userSpaceOnUse",
  id: "gpl_b",
  x1: "27.7",
  x2: ".5",
  y1: "15.5",
  y2: "15.5"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFE000"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".4",
  stopColor: "#FFBD00"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".8",
  stopColor: "orange"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#FF9C00"
})), /*#__PURE__*/React.createElement("linearGradient", {
  gradientUnits: "userSpaceOnUse",
  id: "gpl_c",
  x1: "17.5",
  x2: "-7.5",
  y1: "13",
  y2: "-12.5"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF3A44"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#C31162"
})), /*#__PURE__*/React.createElement("linearGradient", {
  gradientUnits: "userSpaceOnUse",
  id: "gpl_d",
  x1: "-2.1",
  x2: "9.1",
  y1: "37.3",
  y2: "25.9"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#32A071"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".1",
  stopColor: "#2DA771"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".5",
  stopColor: "#15CF74"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".8",
  stopColor: "#06E775"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#00F076"
})))), {
  viewBox: '0 0 128 32'
});